module.exports = __webpack_public_path__ + "img/imagen_parrafo_6.f1aad42f.jpg";